// Sikhi Adventures — Theme JS

// Add to cart
function addToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => { window.location.href = '/cart'; })
  .catch(err => console.error('Add to cart error:', err));
}

// Variant selector on product page
function selectVariant(btn) {
  document.querySelectorAll('.sa-format-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const variantId = btn.dataset.variant;
  const price = btn.dataset.price;
  document.getElementById('variant-id').value = variantId;
  if (document.getElementById('product-price')) {
    document.getElementById('product-price').textContent = price;
  }
  if (document.getElementById('btn-price')) {
    document.getElementById('btn-price').textContent = price;
  }
}

// Mobile menu close on outside click
document.addEventListener('click', function(e) {
  const menu = document.querySelector('.sa-mobile-menu');
  const btn = document.querySelector('.sa-mobile-menu-btn');
  if (menu && btn && !menu.contains(e.target) && !btn.contains(e.target)) {
    menu.classList.remove('open');
  }
});

// Announcement Slider
(function() {
  var messages = document.querySelectorAll('.sa-announcement-slider__message');
    var current = 0;
      var total = messages.length;
        var timer;

          function showMessage(index) {
              messages[current].classList.remove('active');
                  current = (index + total) % total;
                      messages[current].classList.add('active');
                          resetTimer();
                            }

                              function resetTimer() {
                                  clearInterval(timer);
                                      timer = setInterval(function() {
                                            showMessage(current + 1);
                                                }, 4000);
                                                  }

                                                    window.saSliderNext = function() { showMessage(current + 1); };
                                                      window.saSliderPrev = function() { showMessage(current - 1); };

                                                        if (total > 0) resetTimer();
                                                        })();

                                                        // Product Gallery Autoplay
                                                        (function() {
                                                        var galleries = document.querySelectorAll('.sa-product__gallery');
                                                        galleries.forEach(function(gallery) {
                                                        var thumbs = gallery.querySelectorAll('.sa-product__thumb');
                                                        if (thumbs.length < 2) return;
                                                        var mainImg = gallery.querySelector('.sa-product__main-image img');
                                                        var current = 0;
                                                        var timer;

                                                        function showImage(index) {
                                                        current = (index + thumbs.length) % thumbs.length;
                                                        var thumb = thumbs[current];
                                                        if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
                                                        thumbs.forEach(function(t) { t.classList.remove('active'); });
                                                        thumb.classList.add('active');
                                                        }

                                                        function resetTimer() {
                                                        clearInterval(timer);
                                                        timer = setInterval(function() {
                                                        showImage(current + 1);
                                                        }, 4500);
                                                        }

                                                        thumbs.forEach(function(thumb, i) {
                                                        thumb.addEventListener('click', function() {
                                                        showImage(i);
                                                        resetTimer();
                                                        });
                                                        });

                                                        gallery.addEventListener('mouseenter', function() { clearInterval(timer); });
                                                        gallery.addEventListener('mouseleave', function() { resetTimer(); });

                                                        resetTimer();
                                                        });
                                                        })();